import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Button from "elevate-ui/Button";

import { withGlobalContext } from "../common/GlobalContext";
import ChevronLeft from "../common/icons/ChevronLeft";
import ChevronRight from "../common/icons/ChevronRight";

type Props = {
  classes: Object,
  className: string,
  clientLoaded: boolean,
  pdpNavigation: Object,
};

const PdpNavigation = ({
  classes,
  className,
  clientLoaded,
  pdpNavigation: {
    navigateBack,
    navigateNext,
    navigatePrevious,
    showNext,
    showPrevious,
  },
}: Props) =>
  clientLoaded &&
  (showNext || showPrevious) && (
    <div className={classNames(classes.root, className)}>
      <Button onClick={navigateBack}>Back</Button>
      <div className={classes.pdpMessage}>
        You are viewing this property in a series.
      </div>
      <div className={classes.pdpButtons}>
        {showPrevious && (
          <Button onClick={navigatePrevious}>
            <ChevronLeft
              width={12}
              height={12}
              style={{ marginRight: "4px" }}
            />
            <span>Previous Listing</span>
          </Button>
        )}
        {showNext && (
          <Button onClick={navigateNext}>
            <span>Next Listing</span>
            <ChevronRight
              width={12}
              height={12}
              style={{ marginLeft: "4px" }}
            />
          </Button>
        )}
      </div>
    </div>
  );

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    background: theme.colors.primary["500"],
    color: theme.colors.primaryFontColor,
    filter: "brightness(80%)",

    "& > * + *": {
      marginLeft: theme.spacing.unit * 0.5,
    },
  },
  pdpMessage: {
    flex: "1",
    minWidth: "160px",
    fontSize: "14px",
    marginLeft: theme.spacing.unit,
  },
  pdpButtons: {
    display: "flex",
    alignItems: "center",
  },
}))(withGlobalContext(PdpNavigation));
